<template>
  <ExpandableCell :data-key="dataKey" :field="column.field">
    <!-- Collapsed content -->
    <template #collapsed>
      {{ dateArrayValueRendered?.join(', ') }}
    </template>
    <!-- Expanded content -->

    <template #expanded>
      <div>
        <div v-for="(arrayValue, arrayIndex) in dateArrayValueRaw" :key="arrayIndex">
          <div class="pb-1">{{ arrayValue }}</div>
        </div>
      </div>
    </template>
  </ExpandableCell>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';

import { formatDate } from '@/utils/dateUtils';

import type { DataTableCellProps } from './templateTypes';

const props = defineProps<DataTableCellProps>();
const { locale } = useI18n();

const dateArrayValueRendered = computed(() => {
  const { cell } = props;
  const value = cell;
  const renderedValue = value?.meta?.('renderedValue');
  return Array.isArray(renderedValue) ? renderedValue : [renderedValue];
});

const dateArrayValueRaw = computed(() => {
  const { cell } = props;
  const value = cell;
  const rawvalue = value?.meta?.('rawvalue');
  const rawArray = Array.isArray(rawvalue) ? rawvalue : [rawvalue];

  // Format each raw date value using locale-aware formatting
  return rawArray.map((dateValue) => formatDate(dateValue, locale.value, 'date'));
});
</script>
